import { render, staticRenderFns } from "./HomeServices.vue?vue&type=template&id=076487b8&scoped=true&"
import script from "./HomeServices.vue?vue&type=script&lang=js&"
export * from "./HomeServices.vue?vue&type=script&lang=js&"
import style0 from "./HomeServices.vue?vue&type=style&index=0&id=076487b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076487b8",
  null
  
)

export default component.exports